export default __webpack_public_path__ + "static/media/img8.a4fd07c7.svg";